enum InfoModalConstants {
  OPEN_INFO_MODAL = '@InfoModalContainer/OPEN_INFO_MODAL',
  CLOSE_INFO_MODAL = '@InfoModalContainer/CLOSE_INFO_MODAL',
}

export default InfoModalConstants;
